import type { ReactNode } from 'react';
import { EntityIconProvider as SharedEntityIconProvider } from '@hqo/entity-icon';

import { useApi } from 'app/shared/contexts/api';

interface EntityIconProviderProps {
  children: ReactNode;
}

/**
 * Credentials for the building-photo lookup behind `BuildingEntityIcon`.
 *
 * Supplied once here rather than per tile: the feed is a list, and threading the token through
 * every row is both noise and the easy way for one row to end up holding a stale one.
 *
 * `authToken` is passed as the live value from the api context rather than a getter — this app
 * receives a static token in its miniapp open params, and the context re-renders on refresh, so
 * the provider hands down the current one either way.
 *
 * Must sit inside `ApiProvider` (for the credentials) and `QueryClientProvider` (the lookup is a
 * react-query call, deduped per building across the page).
 */
export const EntityIconProvider = ({ children }: EntityIconProviderProps): JSX.Element => {
  const { apiUrl, authToken } = useApi();

  return (
    <SharedEntityIconProvider apiUrl={apiUrl} authToken={authToken}>
      {children}
    </SharedEntityIconProvider>
  );
};
